// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"626":"69741164","748":"90b59572"}[chunkId] + ".chunk.css";
};